import { COLORS } from "shared/consts";

export const CollapseButtonIcon = () => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                              width="24.000000"
                                             height="24.000000" fill="none">
    <path id="Union"
          d="M8.47115 11.4692L13.9711 5.99976L15.0289 7.06337L10.0636 12.001L15.0289 16.9387L13.9711 18.0023L8.47115 12.5328C8.32959 12.392 8.25 12.2007 8.25 12.001C8.25 11.8014 8.32959 11.61 8.47115 11.4692Z"
          fill={COLORS.FG.SOFT} fillRule="evenodd"/>
</svg>

